import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthUtil } from './utils/auth';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'legal-trip';
  langs = ['en', 'pt', 'es'];

  constructor(private translateService: TranslateService, public router: Router) {
    this.router.events.subscribe(event => {

      if (event instanceof NavigationEnd) {
        gtag('set', 'page', event.urlAfterRedirects);
        gtag('send', 'pageview');
      }
    });
  }

  public ngOnInit(): void {
    AuthUtil.setEdicao(null);
    let browserlang = this.translateService.getBrowserLang();
    let idioma = localStorage.getItem("idioma");
    if (idioma) {
      this.translateService.setDefaultLang(idioma);
    } else if (this.langs.indexOf(browserlang) > -1) {
      this.translateService.setDefaultLang(browserlang);
    } else {
      this.translateService.setDefaultLang('pt');
    }
  }
}
